/**
 * useLocale.js — lightweight locale switcher (no vue-i18n).
 */
import { computed, ref, watch } from 'vue';
import * as en from '../data/landingContent.en.js';
import * as de from '../data/landingContent.de.js';
import * as planMarketingEn from '../data/planMarketing.en.js';
import * as planMarketingDe from '../data/planMarketing.de.js';

const STORAGE_KEY = 'mw-locale';
const bundles = { en, de };
const marketingBundles = { en: planMarketingEn, de: planMarketingDe };

const locale = ref(
  typeof localStorage !== 'undefined'
    ? localStorage.getItem(STORAGE_KEY) || 'en'
    : 'en',
);

watch(locale, (val) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = val === 'de' ? 'de' : 'en';
  }
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, val);
  }
}, { immediate: true });

export function useLocale() {
  const content = computed(() => bundles[locale.value] ?? bundles.en);
  const planMarketing = computed(() => marketingBundles[locale.value] ?? marketingBundles.en);

  function setLocale(next) {
    locale.value = next === 'de' ? 'de' : 'en';
  }

  function toggleLocale() {
    setLocale(locale.value === 'en' ? 'de' : 'en');
  }

  return {
    locale,
    content,
    planMarketing,
    setLocale,
    toggleLocale,
    isEnglish: computed(() => locale.value === 'en'),
  };
}
